import Reflux from 'reflux';

const MessagesActions = Reflux.createActions({
  loadMessage: { asyncResult: true },
  fieldTerms: { asyncResult: true },
  loadRawMessage: { asyncResult: true },
});

export default MessagesActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/messages/MessagesActions.js